let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("dD3C6")).then(() => parcelRequire('aNP5E'));